var map = {
	"./animals.jpg": "fbe9",
	"./baby-smiling.jpg": "6c8e",
	"./interview.jpg": "c3aa",
	"./perfect-sunset.jpg": "ff30",
	"./restaurant-dining.jpg": "5d15",
	"./wheelchair-couple.jpg": "dd63"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "64de";